export const payroll = [
    {
        id: "1",
        nombre: "Andres Romero Huerta",
        puesto: "Operador Offset · SM-74",
        sueldoBase: 15950,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 15950,
        fecha: "2024-05-08",
        tipoNomina: "Sindicato",
        prestamo: {nombre: "Pago adelanto", valor: 1200}
    },
    {
        id: "2",
        nombre: "Juan Perez",
        puesto: "Operador 1 · SM-44",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2025-03-17",
        tipoNomina: "Sindicato",
        prestamo: {nombre: "Pago motocicleta (3/12)", valor: 1350}

    },
    {
        id: "3",
        nombre: "Juan Perez",
        puesto: "Contador",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2025-07-22",
        tipoNomina: "Confianza",
        prestamo: {nombre: "Pago coche (4/14)", valor: 2200}
    },
    {
        id: "4",
        nombre: "Juan Perez",
        puesto: "Practicante de Sistemas",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2026-10-08",
        tipoNomina: "Quincena",
        prestamo: {nombre: "Pago adelanto", valor: 3200}

    },
    {
        id: "5",
        nombre: "Andres Romero Prueba1",
        puesto: "Practicante de RH",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2024-03-15",
        tipoNomina: "Confianza",
        prestamo: {nombre: "Pago adelanto", valor: 1200}
    },
    {
        id: "6",
        nombre: "Andres Romero Prueba2",
        puesto: "Operador Offset · SM-74",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2024-03-15",
        tipoNomina: "Quincena",
        prestamo: {nombre: "Pago adelanto", valor: 1200}
    },
    {
        id: "7",
        nombre: "Andres Romero Prueba3",
        puesto: "Administrador de almacén · SM-74",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2024-05-15",
        tipoNomina: "Sindicato",
        prestamo: {nombre: "Pago adelanto", valor: 1200}
    },
    {
        id: "8",
        nombre: "Andres Romero Prueba4",
        puesto: "Encargado de mantenimiento",
        sueldoBase: 17650.43,
        tiempoExtra: {horas: 6, valor: 750},
        bonoProd: 750,
        bonoPuntAsis: 0,
        bonoEBIDTA: 0,
        faltas: {numFaltas: 1, valor: 550},
        totalExtras: 1500,
        totalDescuentos: 550,
        granTotal: 17650.43,
        fecha: "2024-05-15",
        tipoNomina: "Confianza",
        prestamo: {nombre: "Pago adelanto", valor: 1200}
    }
    
]